export const SPECIAL_AUDITS = ['5s', 'bozp']
